module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/borders-selection-prize.71515ddd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/borders-selection-prize.png
// module id = 2833
// module chunks = 11